<script setup lang="ts">
const props = defineProps<{
  googlePlaceId?: string | null
}>()

const modelValue = defineModel<any>('modelValue', { required: true })

const selected = ref<{ googlePlaceId: any }>({
  googlePlaceId: null
})

watch(
  () => props.googlePlaceId,
  (newValue) => {
    if (newValue) {
      selected.value.googlePlaceId = newValue
    }
  },
  { immediate: true }
)

watch(
  selected,
  (newValue) => {
    modelValue.value = newValue.googlePlaceId
  },
  { deep: true }
)
</script>

<template>
  <AppGooglePlaceIdAutoComplete v-model="selected.googlePlaceId" />
</template>
